
export { GGUSection } from "/codebuild/output/src3584820406/src/packages/shared-components/src/campaign/GGUSection.tsx"